// Guides offerts (lead magnets). Pour en ajouter un : copiez un bloc et changez les champs.
export const GUIDES = [
  {
    slug: "reflexologie",
    title: "3 gestes de réflexologie plantaire à faire chez soi",
    excerpt: "Un rituel bien-être simple et doux pour vos pieds — et pour tout votre corps.",
    cover: "/images/reflexologie.jpg",
    coverAlt: "Mains pratiquant la réflexologie plantaire sur un pied",
    to: "/guide",
  },
  {
    slug: "bouffees",
    title: "Apaiser les bouffées de chaleur",
    excerpt: "3 points de réflexologie à masser chez vous, en douceur, pour retrouver fraîcheur et calme.",
    cover: "/images/reflexo-pratique.jpg",
    coverAlt: "Gros plan d'un auto-massage du pied en réflexologie",
    to: "/guide-bouffees-de-chaleur",
  },
];
